import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { EnvironRow, EnvironSegment } from './OpsToday.styled'

export const EnvironStrip = () => {
  const environ = useSelector((s: RootState) => s.opsEnviron.environ)

  if (!environ) return null

  const blast = environ.blastWindows[0]
  const { weather } = environ
  const weatherBad = !weather.liftsOk || !weather.roadsOk
  const lifts = weather.liftsOk ? 'lifts OK' : 'lifts suspended'
  const roads = weather.roadsOk ? 'roads OK' : 'roads closed'
  const tempLabel = weather.tempC != null ? `${weather.tempC}°C` : '—'
  const windLabel = weather.windKmh != null ? `${weather.windKmh} km/h` : '—'
  return (
    <EnvironRow>
      <EnvironSegment $tone={blast ? 'warning' : 'neutral'}>
        {blast
          ? `⚠ Blast window: ${blast.zone} closed ${blast.from}–${blast.to} — scheduler will not queue work there`
          : 'No blast windows today'}
      </EnvironSegment>
      <EnvironSegment $tone={weatherBad ? 'danger' : 'neutral'}>
        {`${weather.summary} · ${tempLabel} · wind ${windLabel} — ${lifts}, ${roads}`}
      </EnvironSegment>
    </EnvironRow>
  )
}
